module.exports = __webpack_public_path__ + "G2reviews.png?0b719a871df596f378db7a1abb90b3cb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/G2reviews.png
// module id = 4
// module chunks = 0